import { render, staticRenderFns } from "./AdminServicePlaceAdd.vue?vue&type=template&id=31f502f2&scoped=true&"
import script from "./AdminServicePlaceAdd.vue?vue&type=script&lang=js&"
export * from "./AdminServicePlaceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f502f2",
  null
  
)

export default component.exports